import { useGlobal } from '~/hooks/useGlobal';

import styles from './BannerMainBlockSkeleton.module.scss';

export const BannerMainBlockSkeleton = () => {
  const { isMobile } = useGlobal();

  return (
    <div className={styles.container} data-mobile={isMobile}>
      <div className={styles.skeleton} />
    </div>
  );
};
